/* eslint-disable */
// Left Side Nav
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'analytics',
        title: 'Analytics',
        type: 'aside',
        icon: 'mat_outline:analytics',
        tooltip: 'Analytics',
        children: [
            {
                id: 'dashboard',
                title: 'Dashboard',
                type: 'basic',
                icon: 'mat_outline:dashboard',
                link: '/analytics/dashboard',
            },
            {
                id: 'updates',
                title: "What's New",
                type: 'basic',
                icon: 'heroicons_outline:sparkles',
                link: '/analytics/updates',
                tooltip: 'See recent BOSS updates and improvements',
            },
            {
                id: 'transactions',
                title: 'Transactions',
                type: 'basic',
                icon: 'heroicons_outline:banknotes',
                link: '/transactions',
            },
            {
                id: 'citic-purchases',
                title: 'CITIC Purchases',
                type: 'basic',
                icon: 'heroicons_outline:globe-asia-australia',
                link: '/analytics/citic-purchases',
                tooltip: 'Monitor CITIC plan purchases and postpaid settlement',
            },
            {
                id: 'genealogy',
                title: 'Genealogy',
                type: 'basic',
                icon: 'feather:org-chart',
                link: '/analytics/genealogy/v2',
            },
            {
                id: 'reports',
                title: 'Reports',
                type: 'collapsable',
                icon: 'mat_outline:auto_graph',
                link: '',
                children: [
                    {
                        id: 'product-sales-summary',
                        title: 'Product Sales Summary',
                        type: 'basic',
                        icon: 'mat_outline:shopping_bag',
                        link: '/analytics/reports/product-sales-summary',
                        tooltip:
                            'Monitor product sales with advanced filtering options',
                    },
                    {
                        id: 'end-of-day-closing',
                        title: 'End of Day Closing',
                        type: 'basic',
                        icon: 'heroicons_outline:clock',
                        link: '/analytics/reports/end-of-day-closing',
                        tooltip:
                            'Compare sales and inventory for daily closing confirmation',
                    },
                    {
                        id: 'delivery-report',
                        title: 'Delivery Report',
                        type: 'basic',
                        icon: 'mat_outline:local_shipping',
                        link: '/analytics/reports/delivery-report',
                        tooltip: 'Review self-pickup orders completed today',
                    },
                    {
                        id: 'ep-egp-performance-report',
                        title: 'EP/EGP Performance',
                        type: 'basic',
                        icon: 'mat_outline:trending_up',
                        link: '/analytics/reports/ep-egp-performance',
                        tooltip: 'View activations, reloads, applied rates, and incentive achievements',
                    },
                    // {
                    //     id: 'big-data-insights',
                    //     title: 'Big Data Insights',
                    //     type: 'basic',
                    //     icon: 'heroicons_outline:chart-bar',
                    //     link: '/analytics/reports/big-data-insights',
                    //     tooltip: 'Run large-scale analytical reports with advanced filters',
                    // },
                    // {
                    //     id: 'member-statements',
                    //     title: 'Member Statements',
                    //     type: 'basic',
                    //     icon: 'heroicons_outline:document-text',
                    //     link: '/analytics/reports/member-statements',
                    //     tooltip: 'Generate transaction history statements by member ID',
                    // },
                    {
                        id: 'consent-report',
                        title: 'Consent Report',
                        type: 'basic',
                        icon: 'heroicons_outline:book-open',
                        link: '/analytics/reports/consent-report',
                    },
                    {
                        id: 'dynamic-report',
                        title: 'Dynamic Report',
                        type: 'basic',
                        icon: 'heroicons_outline:table-cells',
                        link: '/analytics/reports/dynamic-report',
                    },
                    {
                        id: 'corporate-reload-eoy',
                        title: 'EOY Corporate Reloads',
                        type: 'basic',
                        icon: 'mat_outline:summarize',
                        link: '/analytics/reports/corporate-reload-eoy',
                        tooltip: 'EOY summary of corporate reload totals',
                    },
                    {
                        id: 'corporate-reload-summary',
                        title: 'Corporate Reloads Summary',
                        type: 'basic',
                        icon: 'mat_outline:assignment',
                        link: '/analytics/reports/corporate-reload-summary',
                        tooltip: 'Detailed summary of corporate reload transactions',
                    },
                ],
            },
        ],
    },
    {
        id: 'manage-pos',
        title: 'POS',
        type: 'basic',
        icon: 'mat_outline:credit_card',
        link: '/pos',
        tooltip: 'Sales',
    },
    {
        id: 'incentives',
        title: 'Incentives',
        type: 'aside',
        icon: 'heroicons_outline:banknotes',
        tooltip: 'Incentives',
        children: [
            {
                id: 'payout-summary',
                title: 'Payout Summary',
                type: 'basic',
                icon: 'heroicons_outline:currency-dollar',
                link: '/incentives/payout-summary',
            },
            {
                id: 'incentive-ledger',
                title: 'Incentive Ledger',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/incentives/ledger',
            },
            {
                id: 'appeal-incentive',
                title: 'Appeal Incentive',
                type: 'basic',
                icon: 'heroicons_outline:shield-exclamation',
                link: '/incentives/appeal-incentive',
            },
            {
                id: 'dealer-incentives',
                title: 'Dealer Incentives',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar-square',
                link: '/incentives/dealers',
                tooltip: 'Review EP/EGP statements and rules',
            },
        ],
    },
    {
        id: 'configuration',
        title: 'Configurations',
        type: 'aside',
        icon: 'heroicons_outline:cog-8-tooth',
        tooltip: 'Configurations',
        children: [
            // {
            //     id: 'membership-settings',
            //     title: 'Membership Settings',
            //     type: 'basic',
            //     icon: 'mat_outline:card_giftcard',
            //     link: '/configuration/membership',
            // },
            // {
            //     id: 'discount-settings',
            //     title: 'Discount Settings',
            //     type: 'basic',
            //     icon: 'heroicons_outline:receipt-percent',
            //     link: '/configuration/discount',
            // },
            {
                id: 'validation-rules',
                title: 'Validation Rules',
                type: 'basic',
                icon: 'heroicons_outline:receipt-percent',
                link: '/configuration/validation-rules',
            },
            {
                id: 'incentive-configs',
                title: 'Incentive Configuration',
                type: 'basic',
                icon: 'heroicons_outline:adjustments-horizontal',
                link: '/configuration/incentive-configs',
            },
            // {
            //     id: 'payment',
            //     title: 'Payment',
            //     type: 'basic',
            //     icon: 'feather:paymentIcon',
            //     link: '/configuration/payment',
            // },
            {
                id: 'pricing-rules',
                title: 'Pricing Rules',
                type: 'basic',
                icon: 'heroicons_outline:adjustments-horizontal',
                link: '/configuration/pricing-rules',
            },
        ],
    },
    {
        id: 'subscribers',
        title: 'Subscribers',
        type: 'aside',
        icon: 'heroicons_outline:user-group',
        tooltip: 'Subscribers',
        children: [
            // {
            //     id: 'all-subscriber',
            //     title: 'All Users',
            //     type: 'basic',
            //     icon: 'feather:subscriber',
            //     link: '/subscriber/list',
            // },
            {
                id: 'view-subscriber',
                title: 'View Subscriber',
                type: 'basic',
                icon: 'heroicons_outline:magnifying-glass',
                link: '/subscriber/view-subscriber',
            },
            {
                id: 'failed-operations',
                title: 'Failed Operations',
                type: 'basic',
                icon: 'heroicons_outline:exclamation-triangle',
                link: '/subscriber/failed-operations',
            },
            {
                id: 'failed-registrations',
                title: 'Failed Registrations',
                type: 'basic',
                icon: 'heroicons_outline:exclamation-circle',
                link: '/subscriber/failed-registrations',
            },
            {
                id: 'register-subscriber',
                title: 'Register Subscriber',
                type: 'basic',
                icon: 'heroicons_outline:user-plus',
                link: '/subscriber/register-subscriber',
            },
            // {
            //     id: 'pending-subscriber',
            //     title: 'Pending Subscribers',
            //     type: 'basic',
            //     icon: 'mat_outline:pending_actions',
            //     link: '/subscriber/pending-subscriber',
            // },
            // {
            //     id: 'verify-subscriber',
            //     title: 'Verify Subscriber',
            //     type: 'basic',
            //     icon: 'mat_outline:domain_verification',
            //     link: '/subscriber/verify-subscriber',
            // },
            // {
            //     id: 'manage-service',
            //     title: 'Manage Service',
            //     type: 'basic',
            //     icon: 'mat_outline:manage_accounts',
            //     link: '/subscriber/service-subscriber',
            // },
            {
                id: 'manage-service',
                title: 'Port-in Requests',
                type: 'basic',
                icon: 'mat_outline:edgesensor_high',
                link: '/subscriber/port-in-requests',
            },
            {
                id: 'port-out-requests',
                title: 'Port-out Requests',
                type: 'basic',
                icon: 'mat_outline:edgesensor_high',
                link: '/subscriber/port-out-requests',
            },
            {
                id: 'stuck-numbers',
                title: 'Stuck MNP',
                type: 'basic',
                icon: 'heroicons_outline:signal-slash',
                link: '/subscriber/stuck-numbers',
            },
            {
                id: 'otp-management',
                title: 'OTP Management',
                type: 'basic',
                icon: 'heroicons_outline:shield-check',
                link: '/subscriber/otp-management',
            },
            {
                id: 'sim-replacement',
                title: 'SIM Replacement',
                type: 'basic',
                icon: 'heroicons_outline:arrow-path',
                link: '/subscriber/sim-replacement',
            },
            {
                id: 'change-upline',
                title: 'Change Upline',
                type: 'basic',
                icon: 'heroicons_outline:arrow-up-circle',
                link: '/subscriber/change-upline',
            },
            {
                id: 'transfer-ownership',
                title: 'Transfer Ownership',
                type: 'basic',
                icon: 'heroicons_outline:arrows-right-left',
                link: '/subscriber/transfer-ownership',
            },
            {
                id: 'manage-messaging',
                title: 'Communication',
                type: 'basic',
                icon: 'mat_outline:sms',
                link: '/messaging',
                //tooltip: 'Manage SMS and push notifications',
            },
        ],
    },
    {
        id: 'organization',
        title: 'Organizations',
        icon: 'heroicons_outline:building-office',
        tooltip: 'Supplier, Branches & Corporate Management',
        type: 'aside',
        children: [
            {
                id: 'supplier-management',
                title: 'Supplier Management',
                type: 'basic',
                icon: 'heroicons_outline:building-office-2',
                link: '/organization/supplier',
            },
            {
                id: 'branch-management',
                title: 'Branch Management',
                type: 'basic',
                icon: 'mat_outline:scatter_plot',
                link: '/organization/branch',
            },
            {
                id: 'corporate-management',
                title: 'Corporate Management',
                type: 'basic',
                icon: 'heroicons_outline:building-office-2',
                link: '/organization/corporate',
            },
            {
                id: 'dealer-profile-management',
                title: 'Dealer Profiles',
                type: 'basic',
                icon: 'heroicons_outline:identification',
                link: '/organization/dealers',
                tooltip: 'Appoint and manage EP/EGP dealer profiles',
            },
        ],
    },
    {
        id: 'products',
        title: 'Products',
        type: 'aside',
        icon: 'mat_outline:shopping_bag',
        tooltip: 'Products',
        children: [
            {
                id: 'product-skus',
                title: 'Product SKUs',
                type: 'collapsable',
                icon: 'mat_outline:category',
                children: [
                    {
                        id: 'sim-products',
                        title: 'Sim/e-sim',
                        type: 'basic',
                        icon: 'mat_outline:sim_card',
                        link: '/products/skus/sim',
                    },
                    {
                        id: 'plans',
                        title: 'Plans',
                        type: 'basic',
                        icon: 'mat_outline:signal_cellular_alt',
                        link: '/products/skus/plans',
                    },
                    {
                        id: 'reloads',
                        title: 'Reloads',
                        type: 'basic',
                        icon: 'mat_outline:signal_cellular_alt',
                        link: '/products/skus/reloads',
                    },
                    {
                        id: 'merchandise',
                        title: 'Merchandise',
                        type: 'basic',
                        icon: 'mat_outline:storefront',
                        link: '/products/skus/merchandise',
                    },
                    {
                        id: 'kits',
                        title: 'Kits',
                        type: 'basic',
                        icon: 'mat_outline:backpack',
                        link: '/products/skus/kits',
                    },
                    {
                        id: 'msisdn',
                        title: 'MSISDN',
                        type: 'basic',
                        icon: 'mat_outline:sim_card',
                        link: '/products/skus/msisdn',
                    },
                    {
                        id: 'foc',
                        title: 'Free of Charge',
                        type: 'basic',
                        icon: 'mat_outline:card_giftcard',
                        link: '/products/skus/foc',
                    },
                    {
                        id: 'service',
                        title: 'Services',
                        type: 'basic',
                        icon: 'mat_outline:miscellaneous_services',
                        link: '/products/skus/service',
                    },
                ],
            },
            {
                id: 'bundles',
                title: 'Bundles',
                type: 'basic',
                icon: 'mat_outline:inventory_2',
                link: '/products/bundles',
            },
            {
                id: 'addons',
                title: 'Addons',
                type: 'basic',
                icon: 'mat_outline:inventory_2',
                link: '/products/addons',
            },
        ],
    },
    {
        id: 'manage-inventory',
        title: 'Inventory',
        type: 'aside',
        icon: 'mat_outline:inventory',
        tooltip: 'Inventory',
        children: [
            {
                id: 'stock-in',
                title: 'Stock In',
                type: 'collapsable',
                icon: 'mat_outline:input',
                children: [
                    {
                        id: 'manufacturing-data',
                        title: 'Manufacturing Data',
                        type: 'basic',
                        icon: 'mat_outline:upload_file',
                        link: '/inventory/stock-in/manufacturing-data',
                    },
                    {
                        id: 'physical-stock',
                        title: 'Physical Stock',
                        type: 'basic',
                        icon: 'mat_outline:inventory',
                        link: '/inventory/stock-in/physical',
                    },
                ],
            },
            {
                id: 'stock-transfer',
                title: 'Stock Transfers',
                type: 'basic',
                icon: 'mat_outline:swap_horiz',
                link: '/inventory/stock-transfer',
            },
            {
                id: 'delivery-order',
                title: 'Delivery Orders',
                type: 'basic',
                icon: 'mat_outline:local_shipping',
                link: '/inventory/delivery-orders',
            },
            {
                id: 'inventory-movements',
                title: 'Inventory Movements',
                type: 'basic',
                icon: 'mat_outline:swap_vertical_circle',
                link: '/inventory/movements',
            },
            {
                id: 'convert-sku',
                title: 'Convert SKU',
                type: 'basic',
                icon: 'mat_outline:swap_horiz',
                link: '/inventory/convert-sku',
            },
            {
                id: 'orders',
                title: 'Orders',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list',
                link: '/inventory/orders',
            },
            {
                id: 'msisdn-lookup',
                title: 'MSISDN Lookup',
                type: 'basic',
                icon: 'heroicons_outline:magnifying-glass',
                link: '/inventory/msisdn-lookup',
            },
            {
                id: 'imsi-lookup',
                title: 'SIM Card Lookup',
                type: 'basic',
                icon: 'heroicons_outline:magnifying-glass-circle',
                link: '/inventory/imsi-lookup',
            },
            {
                id: 'pin-management',
                title: 'PIN Management',
                type: 'collapsable',
                icon: 'mat_outline:pin',
                children: [
                    // {
                    //     id: 'pin-dealers',
                    //     title: 'Manage Dealers',
                    //     type: 'basic',
                    //     icon: 'mat_outline:store',
                    //     link: '/inventory/pin-management/dealers',
                    // },
                    {
                        id: 'pin-batches',
                        title: 'Manage Bulk PIN',
                        type: 'basic',
                        icon: 'mat_outline:inventory_2',
                        link: '/inventory/pin-management/pins',
                    },
                    {
                        id: 'scratch-cards',
                        title: 'Scratch Cards',
                        type: 'basic',
                        icon: 'mat_outline:confirmation_number',
                        link: '/inventory/pin-management/scratch-cards',
                    },
                ],
            },
        ],
    },
    // {
    //     id: 'services',
    //     title: 'Services',
    //     type: 'aside',
    //     icon: 'heroicons_outline:squares-plus',
    //     tooltip: 'Services',
    //     children: [
    //         {
    //             id: 'reload-pin',
    //             title: 'Top Up by PIN',
    //             type: 'basic',
    //             icon: 'mat_outline:pin',
    //             link: '/services/reload-pin',
    //         },
    //         {
    //             id: 'reload-online',
    //             title: 'Online Top Up',
    //             type: 'basic',
    //             icon: 'feather:online-pay',
    //             link: '/services/reload-online',
    //         },
    //     ],
    // },
    // {
    //     id: 'app-management',
    //     title: 'App Management',
    //     type: 'aside',
    //     icon: 'heroicons_outline:device-phone-mobile',
    //     tooltip: 'App Management',
    //     children: [
    //         {
    //             id: 'sitemap',
    //             title: 'Manage Sitemap',
    //             type: 'basic',
    //             icon: 'heroicons_outline:presentation-chart-line',
    //             link: '/app-management/sitemap',
    //         },
    //         {
    //             id: 'mobile-app',
    //             title: 'Mobile App',
    //             type: 'collapsable',
    //             icon: 'heroicons_outline:device-phone-mobile',
    //             children: [
    //                 {
    //                     id: 'splash',
    //                     title: 'Splash Screen',
    //                     type: 'basic',
    //                     icon: 'heroicons_outline:view-columns',
    //                     link: '/app-management/splash-screen',
    //                 },
    //                 {
    //                     id: 'promotions',
    //                     title: 'Promotions',
    //                     type: 'basic',
    //                     icon: 'heroicons_outline:photo',
    //                     link: '/app-management/promotions',
    //                 },
    //                 {
    //                     id: 'campaign',
    //                     title: 'Campaign',
    //                     type: 'basic',
    //                     icon: 'mat_outline:campaign',
    //                     link: '/app-management/campaign',
    //                 },
    //             ],
    //         },
    //     ],
    // },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
    },
];
